<template>
    <div>
<!--        <DashboardTop/>-->
<!--        <CCard>-->

            <div class="bg-revenue" >
                <CTabs class="mb-5">
                    <CTab :title="$t('sales')">
                        <CCard style="margin-bottom: 3px">


                            <barChart chart_id="sale_amount" :label="$t('MonthlySalesReportByAmount')" bar-color="#3399FF"
                                      style="height:200px;margin-top:5px;"
                                      :chart_datas="sale_amount"/>
                            <barChart :label="$t('MonthlySalesReportByQuantity')" bar-color="#3399FF" style="height:200px;margin-top:5px;"
                                      chart_id="sale_qty"
                                      :chart_datas="sale_qty"/>
                        </CCard>


                    </CTab>
                    <CTab :title="$t('items')">
                        <CCard style="margin-bottom: 3px">

                            <barChart :label="$t('CurrentMonthlySalesReportByItem')" bar-color="#3399FF"
                                      style="height:200px;margin-top:5px;" :chart_datas="sale_products"/>
                        </CCard>
                        <CRow>
                            <CCol col="12"  style="padding-inline-end: 3px;" >
                                <CCard style="margin-bottom: 3px">
                                    <barChart chart_id="sale_item" :label="$t('SalesReportByCategory')" bar-color="#3399FF"
                                              style="height:200px;margin-top:5px;" :chart_datas="sale_category"/>
                                </CCard>
                            </CCol>
<!--                            <CCol col="4"  style="padding-inline-start: 3px;" >-->
<!--                                <CCard style="margin-bottom: 3px">-->
<!--                                    &lt;!&ndash;                                    <DonatChart chart_id="sale_category" label="Revenue Item Category"&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                                bar-color="#3399FF"&ndash;&gt;-->
<!--                                    &lt;!&ndash;                                                style="height:200px;margin-top:5px;" :chart_datas="donat_data_set"/>&ndash;&gt;-->
<!--                                    <CustomDonutChart-->
<!--                                            chart_id="sale_category" :label="$t('SalesReportByCategory')"-->
<!--                                            bar-color="#3399FF"-->
<!--                                            style="height:200px;margin-top:5px;" :chart_datas="donat_data_set"-->
<!--                                    />-->
<!--                                </CCard>-->
<!--                            </CCol>-->
                        </CRow>
                    </CTab>
                    <CTab :title="$t('ItemsTurnover')">
                        <CCard style="margin-bottom: 3px">

                            <barChart :label="$t('TOP20SellingItems')" bar-color="#3399FF"
                                      style="height:200px;margin-top:5px;" :chart_datas="top20sale_products"/>
                        </CCard>
                            <CRow>
                                <CCol col="12"  style="padding-inline-end: 3px;" >
                                    <CCard style="margin-bottom: 3px">
                                    <barChart chart_id="sale_item" :label="$t('20LowSalesItems')" bar-color="#3399FF"
                                              style="height:200px;margin-top:5px;" :chart_datas="low20sale_products"/>
                                    </CCard>
                                </CCol>
<!--                                <CCol col="4"  style="padding-inline-start: 3px;" >-->
<!--                                    <CCard style="margin-bottom: 3px">-->
<!--&lt;!&ndash;                                    <DonatChart chart_id="sale_category" label="Revenue Item Category"&ndash;&gt;-->
<!--&lt;!&ndash;                                                bar-color="#3399FF"&ndash;&gt;-->
<!--&lt;!&ndash;                                                style="height:200px;margin-top:5px;" :chart_datas="donat_data_set"/>&ndash;&gt;-->
<!--                                        <CustomDonutChart-->
<!--                                                chart_id="sale_category" :label="$t('20LowSalesItems')"-->
<!--                                                bar-color="#3399FF"-->
<!--                                                style="height:200px;margin-top:5px;" :chart_datas="donat_data_set"-->
<!--                                        />-->
<!--                                    </CCard>-->
<!--                                </CCol>-->
                            </CRow>
                    </CTab>
                    <CTab :title="$t('Customers')">
                            <CRow>
                                <CCol col="12">
                                    <CCard style="margin-bottom: 3px">
                                    <barChart chart_id="sale_customers_amount" :label="$t('Top20Customers')"
                                              bar-color="#3399FF"
                                              style="height:200px;margin-top:5px;"
                                              :chart_datas="sale_customers_amount_report"/>
                                    </CCard>
                                </CCol>
                                <CCol col="12">
                                    <CCard style="margin-bottom: 3px">
                                    <barChart chart_id="sale_customers_qty" :label="$t('20LowCustomers')"
                                              bar-color="#3399FF"
                                              style="height:200px;margin-top:5px;"
                                              :chart_datas="sale_customers_qty_report"/>
                                    </CCard>
                                </CCol>
                            </CRow>

                    </CTab>

                    <CTab :title="$t('TypeOfSales')">


                            <CRow>
                                <CCol col="8"  style="padding-inline-end: 3px;" >
                                    <CCard style="margin-bottom: 3px">
                                    <barChart chart_id="pur_suppliers_qty" :label="$t('TypeOfPayment')" bar-color="#f9b115"
                                              style="height:200px;margin-top:5px;" :chart_datas="cash_delivery_amount"/>
                                    </CCard>
                                </CCol>
                                <CCol col="4"  style="padding-inline-start: 3px;" >
                                    <CCard style="margin-bottom: 3px">
<!--                                    <DonatChart label="Cash" bar-color="#f9b115"-->
<!--                                                style="height:200px;margin-top:5px;" :chart_datas="cash_delivery_amount_percent"/>-->

                                        <CustomDonutChart
                                                :label="$t('TypeOfPayment')" bar-color="#f9b115"
                                                style="height:200px;margin-top:5px;" :chart_datas="cash_delivery_amount_percent"
                                        />
                                    </CCard>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol col="8"  style="padding-inline-end: 3px;" >
                                    <CCard style="margin-bottom: 3px">
                                    <barChart :label="$t('TypeOfDistribution')" bar-color="#f9b115"
                                              chart_id="pur_suppliers_2"

                                              style="height:200px;margin-top:5px;" :chart_datas="cash_delivery_qty"/>
                                    </CCard>
                                </CCol>
                                <CCol col="4"  style="padding-inline-start: 3px;" >
                                    <CCard style="margin-bottom: 3px">
<!--                                    <DonatChart label="Delivery" bar-color="#f9b115"-->
<!--                                                style="height:200px;margin-top:5px;" :chart_datas="cash_delivery_qty_percent"/>-->
                                        <CustomDonutChart
                                                :label="$t('TypeOfDistribution')" bar-color="#f9b115"
                                                style="height:200px;margin-top:5px;" :chart_datas="cash_delivery_qty_percent"
                                        />
                                    </CCard>
                                </CCol>
                            </CRow>

                    </CTab>
                </CTabs>
            </div>

<!--        </CCard>-->
    </div>
</template>

<script>
    import MainSaleChart from '../dashboard/MainSaleChart'
    import barChart from "../panel/dashboardCharts/barChart";
    import DonatChart from "../panel/dashboardCharts/DonatChart";
    import CustomDonutChart from "../charts/CustomDonutChart";
    import WidgetsDropdown from '../widgets/WidgetsDropdown'
    import WidgetsBrand from '../widgets/WidgetsBrand'
    import DashboardTop from "@/views/dashboard/DashboardTop";
    import {bus} from "../../main";
    import axios from "axios";

    export default {
        name: 'Dashboard',
        components: {
          DashboardTop,
            MainSaleChart,
            barChart,
            DonatChart,
            WidgetsDropdown,
            WidgetsBrand,
            CustomDonutChart
        },
        data() {
            return {
                selected_tab: 1,
                selected: 'Month',
                system_report: [],
                productQty: '',
                selected_chart: 1,
                salesQty: '',
                customerQty: '',
                purchaseQty: '',
                chartInfos: [],
                qtyInfos: [],
                sale_qty: [],
                sale_amount: [],
                sale_products: [],
                top20sale_products: [],
                low20sale_products: [],
                sale_category: [],
                buy_qty: [],
                buy_amount: [],
                buy_products: [],
                buy_category: [],
                sale_chart_report: {},
                sale_customers_qty_report: [],
                sale_customers_amount_report: [],
                buy_customers_qty_report: [],
                buy_customers_amount_report: [],
                profit_loss_bar: [],
                profit_loss_donat: [],
                cash_delivery_amount: [],
                cash_delivery_amount_percent: [],
                cash_delivery_qty: [],
                cash_delivery_qty_percent: [],
                donat_data_set:[],

            }
        },
        computed: {

        },
        mounted() {
            bus.$on('dashboard_chart_selected', (data) => {
                // alert(data);
                this.selected_chart = data;
            });
            // bus.$emit("show_spinner", 'false');
            this.get_dashboard_data();
            // this.get_sale_data(1);
            this.get_sale_data(3);
            // this.get_sale_amount(1);
            this.get_sale_amount(3);
            this.get_sale_items_data(3);
            this.get_top20sale_items_data(3);
            this.get_low20sale_items_data(3);
            // this.get_sale_items_data(1);

            this.get_sale_category_data(3);
            // this.get_sale_category_data(1);

            // this.get_customers_qty_report(1);
            this.get_customers_qty_report(3);

            // this.get_customers_amount_report(1);
            this.get_customers_amount_report(3);

            // this.profit_loss_report();
            this.get_sale_cash_delivery(3);


        },
        methods: {
            get_dashboard_data() {
                var self = this;

                const formData = new FormData();

                axios.post('GetSystemReport', formData, {}).then(function (response) {


                    self.productQty = response.data.data.productQty.toString()
                    self.customerQty = response.data.data.customerQty.toString()
                    self.salesQty = response.data.data.salesQty.toString()
                    self.purchaseQty = response.data.data.purchaseQty.toString()

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_sale_data(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetSalePurQty', formData, {}).then(function (response) {
                    if (type == 1) {
                        self.buy_qty = [];
                        var dat = response.data.data.sort((a, b) => a.title.localeCompare(b.title, undefined, {numeric: true, sensitivity: 'base'}));

                        dat.forEach(function (val) {
                            self.buy_qty.push({
                                qty: val.qty,
                                label: self.get_month_by_number(val.title)
                            })
                        })
                    }

                    if (type == 3) {
                        self.sale_qty = [];
                        var dat3 = response.data.data.sort((a, b) => a.title.localeCompare(b.title, undefined, {numeric: true, sensitivity: 'base'}));

                        dat3.forEach(function (val) {
                            self.sale_qty.push({
                                qty: val.qty,
                                label: self.get_month_by_number(val.title)
                            })
                        })

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_sale_amount(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetSalePurAmount', formData, {}).then(function (response) {
                  var dat = response.data.data.sort((a, b) => a.qty.toString().localeCompare(b.qty.toString(), undefined, {numeric: true, sensitivity: 'base'}));

                    if (type == 1) {
                        self.buy_amount = [];

                        dat.forEach(function (val) {
                            self.buy_amount.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }
                    if (type == 3) {
                        self.sale_amount = [];

                        dat.forEach(function (val) {
                            self.sale_amount.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            get_sale_items_data(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetTopSaleCustomerProducts', formData, {}).then(function (response) {
                    if (type == 3) {
                        self.sale_products = [];

                        response.data.data.forEach(function (val) {
                            self.sale_products.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }
                    if (type == 1) {
                        self.buy_products = [];

                        response.data.data.forEach(function (val) {
                            self.buy_products.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_top20sale_items_data(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetTop20SaleProducts', formData, {}).then(function (response) {
                    if (type == 3) {
                        self.top20sale_products = [];

                        response.data.data.forEach(function (val) {
                            self.top20sale_products.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }
                    if (type == 1) {
                        self.buy_products = [];

                        response.data.data.forEach(function (val) {
                            self.buy_products.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_low20sale_items_data(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetLow20SaleProducts', formData, {}).then(function (response) {
                    if (type == 3) {
                        self.low20sale_products = [];

                        response.data.data.forEach(function (val) {
                            self.low20sale_products.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                        self.low20sale_products.reverse()
                    }
                    if (type == 1) {
                        self.buy_products = [];

                        response.data.data.forEach(function (val) {
                            self.buy_products.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_sale_category_data(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetTopSaleCustomerCategory', formData, {}).then(function (response) {
                    self.sale_chart_report = response.data.data
                    if (type == 3) {
                        self.sale_category = [];
                        self.donat_data_set = [];
                        var color_arr = ['#d99f1a', '#d3bc7c', '#893b04',
                            '#af8f5f', '#4235b4', '#5b4a3a',
                            '#3399ff','#E46651','#2dd5e4',
                            '#5ae400','#0e69e4','#e4258e',
                            '#41B883','#E46651','#e48720']


                        response.data.data.forEach(function (val,index) {
                            self.sale_category.push({
                                qty: val.amount,
                                label: val.title
                            })

                            self.donat_data_set.push({
                                count: self.get_percent(val.amount,self.calculate_items(response.data.data,'amount')),
                                label: val.title,
                                color:color_arr[index]
                            })
                        })

                    }
                    if (type == 1) {
                        self.buy_category = [];

                        response.data.data.forEach(function (val) {
                            self.buy_category.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_customers_qty_report(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetTopSaleCustomers', formData, {}).then(function (response) {
                    if (type == 1) {
                        self.buy_customers_qty_report = [];
                        response.data.data.forEach(function (val) {

                            self.buy_customers_qty_report.push({
                                qty: val.qty,
                                label: (val.title)
                            })
                        })

                    }
                    if (type == 3) {
                        self.sale_customers_qty_report = [];
                        response.data.data.forEach(function (val) {

                            self.sale_customers_qty_report.push({
                                qty: val.qty,
                                label: (val.title)
                            })
                        })

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_customers_amount_report(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetTopSaleCustomersAmnt', formData, {}).then(function (response) {
                    if (type == 1) {
                        self.buy_customers_amount_report = [];

                        response.data.data.forEach(function (val) {
                            self.buy_customers_amount_report.push({
                                qty: val.amount,
                                label: (val.title)
                            })
                        })

                    }
                    if (type == 3) {
                        self.sale_customers_amount_report = [];

                        response.data.data.forEach(function (val) {
                            self.sale_customers_amount_report.push({
                                qty: val.amount,
                                label: (val.title)
                            })
                        })

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_sale_cash_delivery(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetCashDeliveryRpt', formData, {}).then(function (response) {
                    var res = response.data.data;

                    self.cash_delivery_amount = [{label:'Cash',qty:res.cash, color: '#3399ff'},{label:'Credit',qty:res.credit, color: '#E46651'},{label:'Total',qty:res.cash+res.credit}]
                    self.cash_delivery_amount.reverse()
                  self.cash_delivery_amount_percent = [{label: 'Cash', count:self.get_percent(res.cash,res.cash+res.credit), color: '#3399ff'},
                        {label: 'Credit', count: self.get_percent(res.credit,res.cash+res.credit), color: '#E46651'}]

                  self.cash_delivery_qty = [{label:'Collection',qty:res.collection, color: '#3399ff'},{label:'Delivery',qty:res.delivery, color: '#E46651'},{label:'Total',qty:res.collection+res.delivery}]
                    self.cash_delivery_qty.reverse()
                  self.cash_delivery_qty_percent = [{label: 'Collection', count:self.get_percent(res.collection,res.collection+res.delivery), color: '#3399ff'},
                        {label: 'Delivery', count: self.get_percent(res.delivery,res.collection+res.delivery), color: '#E46651'}]
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            profit_loss_report() {
                var self = this;


                const formData = new FormData();

                var url = "GetCredDeptRpt";

                formData.append('CityId', 0);
                formData.append('ProvinceId', 0);
                formData.append('RegionId', 0);
                formData.append('AreaId', 0);
                formData.append('RouteId', 0);
                formData.append('CountryId', 0);
                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        var profit_items = content_data.data;
                        profit_items.forEach(function (val) {
                            val.before_90 = val.balance90
                            if (val.before_90 < 0) {
                                val.before_90 = 0;
                            }
                            val.before_60 = val.balance60
                            if (val.before_60 < 0) {
                                val.before_60 = 0;
                            }
                            val.before_30 = val.balance30
                            if (val.before_30 < 0) {
                                val.before_30 = 0;
                            }
                            val.before_current = val.currentDays
                            if (val.before_current < 0) {
                                val.before_current = 0;
                            }
                            val.before_120 = val.balanceCurrent - (val.before_current + val.before_30 + val.before_60 + val.before_90)

                        })
                        var before_120 =(self.calculate_items(profit_items, "before_120"))
                        var before_90 = (self.calculate_items(profit_items, "before_90"))
                        var before_60 = (self.calculate_items(profit_items, "before_60"))
                        var before_30 = (self.calculate_items(profit_items, "before_30"))
                        var before_current = (self.calculate_items(profit_items, "before_current"))
                        var before_balance = (self.calculate_items(profit_items, "balanceCurrent"))

                        self.profit_loss_bar = [];
                        self.profit_loss_bar.push({label: '120 ' + self.$t('days'), qty: before_120})
                        self.profit_loss_bar.push({label: '90 ' + self.$t('days'), qty: before_90})
                        self.profit_loss_bar.push({label: '60 ' + self.$t('days'), qty: before_60})
                        self.profit_loss_bar.push({label: '30 ' + self.$t('days'), qty: before_30})
                        self.profit_loss_bar.push({label: self.$t('current'), qty: before_current})
                        self.profit_loss_bar.push({label: self.$t('tables.balance'), qty: before_balance})
console.log("balance is ",before_balance)
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },
          get_percent(input,sum){
              if(sum==0||input==0){
                  return 0;
              }
              var per = input*100;
              return (per/sum).toFixed(1);
          },
            get_month_by_number(number) {
                number = parseInt(number);
                if (this.$i18n.locale == 'fa') {
                    switch (number) {
                        case 1:
                            return "فروردین";
                        case 2:
                            return "اردیبهشت";
                        case 3:
                            return "خرداد";
                        case 4:
                            return "تیر";
                        case 5:
                            return "مرداد";
                        case 6:
                            return "شهریور";
                        case 7:
                            return "مهر";
                        case 8:
                            return "آبان";
                        case 9:
                            return "آذر";
                        case 10:
                            return "دی";
                        case 11:
                            return "بهمن";
                        case 12:
                            return "اسفند";

                    }
                } else {
                    switch (number) {
                        case 1:
                            return "Jan";
                        case 2:
                            return "Feb";
                        case 3:
                            return "Mar";
                        case 4:
                            return "Apr";
                        case 5:
                            return "May";
                        case 6:
                            return "Jun";
                        case 7:
                            return "Jul";
                        case 8:
                            return "Aug";
                        case 9:
                            return "Sep";
                        case 10:
                            return "Oct";
                        case 11:
                            return "Nov";
                        case 12:
                            return "Dec";

                    }
                }
            }

        },
    }
</script>
<style>
    .bg-revenue .nav-link.active {
        background: #3399FF;
        color: white;
    }

    .bg-sale .nav-link.active {
        background: #f9b115;
        color: white;
    }

    .bg-profit .nav-link.active {
        background: #2eb85c;
        color: white;
    }
</style>
